/**
 * Welche Töpfe an einem Tag zur Wahl stehen.
 *
 * Töpfe haben einen Gültigkeitszeitraum (Sommergarten, Winter Walk). Angeboten
 * wird nur, was am Tag gilt — die API wiese alles andere ab. Steht eine Kasse
 * noch in einem Topf, der nicht mehr gilt, bleibt er in der Liste, damit die
 * Auswahl zeigt, was ist, statt still den ersten Eintrag.
 */
import type { PoolDto, TopfDto } from "./api";

export function gueltigeToepfe(pools: readonly PoolDto[], date: string): PoolDto[] {
  return pools
    .filter(
      (p) =>
        p.active &&
        (p.validFrom === null || p.validFrom <= date) &&
        (p.validTo === null || p.validTo >= date),
    )
    .sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
}

export function topfAuswahl(
  pools: readonly PoolDto[],
  date: string,
  aktuell: TopfDto | null,
): TopfDto[] {
  const gueltig: TopfDto[] = gueltigeToepfe(pools, date).map((p) => ({ id: p.id, name: p.name }));
  return aktuell && !gueltig.some((p) => p.id === aktuell.id) ? [...gueltig, aktuell] : gueltig;
}
